/**
 * AdminHistoryPanel React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import connect from "react-redux/es/connect/connect";

// Material UI components
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';

// Material UI icons
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// application
import GlobalHistoryPanel from "../information/GlobalHistoryPanel";
import {editObject} from "../../operations/editing";


/**
 * Panel for admin page to show global change history
 *
 * @author Jens Gruschel
 */
class AdminHistoryPanel extends React.Component {

    state = {
        disconnected: false,
        storylines: []
    };

    componentDidMount() {
        this.refreshData();
        this.timer = setInterval(() => {this.refreshData()}, 10000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    refreshData() {
        // TODO
    }

    render() {

        return <ExpansionPanel defaultExpanded={true}>

            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                <Typography>letzte Änderungen</Typography>
            </ExpansionPanelSummary>

            <ExpansionPanelDetails>
                <GlobalHistoryPanel onEdit={this.props.editObject}/>
            </ExpansionPanelDetails>

        </ExpansionPanel>;
    }
}

export default connect(null, {editObject})(AdminHistoryPanel);